import {
  isVisibleAgentCursorWork,
  isVisibleAgentExecutionWork,
} from "@/components/cursors/agent-work-visibility";
import { useTtsPlaybackStore } from "@/desktop/tts-playback-store";
import { useCanvasStore } from "@/stores/canvas-store";
import { useCompanionStore } from "@/stores/companion-store";
import type { ExecutionStatus } from "@/stores/companion-store";
import { useProjectStore } from "@/stores/project-store";

const ACTIVE_EXECUTION_STATUSES = new Set<ExecutionStatus>([
  "running",
  "waiting_approval",
]);

export function useDenkerActivityActive() {
  const currentSpaceId = useProjectStore((s) => s.currentSpace?.id ?? null);
  const agentSpeaking = useTtsPlaybackStore(
    (s) => s.speakingState === "started",
  );
  const hasVisibleCursorWork = useCanvasStore((s) =>
    Array.from(s.agentCursors.values()).some((cursor) => {
      if (cursor.frozen) return false;
      if (currentSpaceId !== null && cursor.spaceId !== currentSpaceId) {
        return false;
      }
      return isVisibleAgentCursorWork(cursor);
    }),
  );
  const hasActiveExecution = useCompanionStore((s) =>
    Array.from(s.executions.values()).some((execution) => {
      if (!ACTIVE_EXECUTION_STATUSES.has(execution.status)) return false;
      if (!isVisibleAgentExecutionWork(execution)) return false;
      return currentSpaceId === null || execution.spaceId === currentSpaceId;
    }),
  );

  return agentSpeaking || hasVisibleCursorWork || hasActiveExecution;
}
